// C:\Users\avnis\CareCoordinatorDashboard\client\src\CareCoordinator\pages\PatientDetail.js

import React, { useState, useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import CCSidebar from "../components/CCSidebar";
import CareJourney from "../components/CareJourney";
import HealthView from "../components/HealthView";
import MedicationView from "../components/Medicationview";
import BaselineView from "../components/BaselineView";
import UploadCgm from "../components/UploadCgm";
import ExportCgm from "../components/ExportCgm";
import HeartRateMonitor from "../components/graphs/enhancedgraph/heartrate";
import { fetchPatientProgram, extractObject, uploadDietPlan, getDietPdfUrl } from "../data/ccProgram";
import { fetchAdminPatientDetail } from "../data/admindata";
import "../styles/PatientDetail.css";

/* ── Small inline icons ── */
function MapIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 16} height={props.size || 16} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
      <line x1="8" y1="2" x2="8" y2="18" />
      <line x1="16" y1="6" x2="16" y2="22" />
    </svg>
  );
}
function ChartIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 16} height={props.size || 16} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10" />
      <line x1="12" y1="20" x2="12" y2="4" />
      <line x1="6" y1="20" x2="6" y2="14" />
    </svg>
  );
}
function PillIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 16} height={props.size || 16} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.5 20.5 3.5 13.5a5 5 0 1 1 7.07-7.07l7 7a5 5 0 1 1-7.07 7.07Z" />
      <line x1="8.5" y1="8.5" x2="15.5" y2="15.5" />
    </svg>
  );
}
function ClipboardIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 16} height={props.size || 16} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
      <path d="M9 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-3" />
      <line x1="8" y1="12" x2="16" y2="12" />
      <line x1="8" y1="16" x2="16" y2="16" />
    </svg>
  );
}
function PhoneIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 12} height={props.size || 12} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92Z" />
    </svg>
  );
}
function GridIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 14} height={props.size || 14} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
    </svg>
  );
}
function LayersIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 14} height={props.size || 14} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 2 7 12 12 22 7 12 2" />
      <polyline points="2 17 12 22 22 17" />
      <polyline points="2 12 12 17 22 12" />
    </svg>
  );
}
/* ── Copy icon for quick phone-number copy ── */
function CopyIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 12} height={props.size || 12} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
  );
}
function CheckIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 12} height={props.size || 12} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}
/* ── Battery icon (used for the device battery field) ── */
function BatteryIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 14} height={props.size || 14} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="6" width="18" height="12" rx="2" ry="2" />
      <line x1="23" y1="13" x2="23" y2="11" />
    </svg>
  );
}
/* ── Heart icon (used for the Enhanced Monitoring tab + field) ── */
function HeartIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 16} height={props.size || 16} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 21s-6.7-4.35-9.33-8.06C.86 10.4 1.2 6.9 3.8 5.1c2.2-1.53 5-.98 6.6 1.02.5.62.9 1.3 1.6 1.3.7 0 1.1-.68 1.6-1.3 1.6-2 4.4-2.55 6.6-1.02 2.6 1.8 2.94 5.3 1.13 7.84C18.7 16.65 12 21 12 21Z" />
    </svg>
  );
}
/* ── Diet icon (utensils) – used for the Upload Diet Plan button ── */
function DietIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 14} height={props.size || 14} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2" />
      <path d="M7 2v20" />
      <path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7" />
    </svg>
  );
}

/* ── Eye icon – used for the View Diet Plan button ── */
function EyeIcon(props) {
  return (
    <svg viewBox="0 0 24 24" width={props.size || 14} height={props.size || 14} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

const TABS = [
  { id: "journey",    text: "Care Journey",       icon: MapIcon,       hint: "Programme phases and daily tasks" },
  { id: "metrics",    text: "Metrics",            icon: ChartIcon,     hint: "Glucose and health graphs" },
  { id: "medication", text: "Medication",         icon: PillIcon,      hint: "Prescribed medicines and adherence" },
  { id: "baseline",   text: "Baseline",           icon: ClipboardIcon, hint: "Baseline assessment details" },
  { id: "enhanced",   text: "Enhanced Monitoring", icon: HeartIcon,    hint: "Real-time heart-rate stream" },
];

/* ── Shared look for the tab toolbar (same on every tab) ── */
const TOOLBAR_STYLE = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 16,
  minHeight: 56,
  padding: "8px 20px",
  marginTop: 12,
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 12,
  boxSizing: "border-box",
};

/* ── Human-friendly label for the "source" field coming from device_info ── */
const SOURCE_LABELS = {
  qring: "qring",
  jcband: "jc band",
};

function getSourceLabel(source, deviceType) {
  if (source && SOURCE_LABELS[String(source).toLowerCase()]) {
    return SOURCE_LABELS[String(source).toLowerCase()];
  }
  return source ? String(source).toLowerCase() : (deviceType ? String(deviceType).toLowerCase() : null);
}

/**
 * Picks the most recently-updated entry from a device_info array and returns
 * its battery level + source + raw updated_at timestamp. Fully defensive —
 * bad/missing data just results in a null return instead of throwing.
 */
function getLatestBatteryInfo(deviceInfoArr) {
  if (!Array.isArray(deviceInfoArr) || deviceInfoArr.length === 0) return null;

  let latest = null;
  let latestTime = -Infinity;

  for (const device of deviceInfoArr) {
    if (!device || typeof device !== "object") continue;

    const ts = device.updated_at ? new Date(device.updated_at).getTime() : NaN;
    const time = Number.isNaN(ts) ? -Infinity : ts;

    if (!latest || time > latestTime) {
      latest = device;
      latestTime = time;
    }
  }

  if (!latest) return null;

  const rawBattery = latest.batery_level ?? latest.battery_level ?? null;
  const batteryNum = rawBattery !== null && rawBattery !== undefined && rawBattery !== ""
    ? Number(rawBattery)
    : null;

  return {
    battery: Number.isFinite(batteryNum) ? batteryNum : null,
    source: getSourceLabel(latest.source, latest.device_type),
    updatedAt: latest.updated_at || null,
  };
}

/**
 * Formats an ISO/date string into IST as "HH:mm DD month YYYY"
 * e.g. "18:30 14 august 2026". Returns null on bad/missing input.
 *
 * The API sends timestamps in UTC but WITHOUT a trailing "Z" (e.g.
 * "2026-08-14T06:51:31.667000"). Without the "Z", JS would parse that as
 * local browser time instead of UTC, so we explicitly mark it as UTC
 * before converting to IST.
 */
function formatISTDateTime(dateStr) {
  if (!dateStr) return null;

  let normalized = String(dateStr).trim();
  // If there's no timezone info (no trailing Z and no +/-HH:MM offset), treat it as UTC.
  const hasTZ = /Z$|[+-]\d{2}:?\d{2}$/.test(normalized);
  if (!hasTZ) {
    normalized = `${normalized}Z`;
  }

  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) return null;

  try {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).formatToParts(d);

    const map = {};
    parts.forEach((p) => { map[p.type] = p.value; });

    if (!map.hour || !map.minute || !map.day || !map.month || !map.year) return null;
    return `${map.hour}:${map.minute} ${map.day} ${map.month.toLowerCase()} ${map.year}`;
  } catch (err) {
    return null;
  }
}

/**
 * Turns a storage key like
 * "prescription/<id>/20261013T072656_Santhosh G — Personalised Diet Plan.pdf"
 * into a readable file name ("Santhosh G — Personalised Diet Plan.pdf").
 */
function getDietFileName(key) {
  if (!key) return null;
  const last = String(key).split("/").pop() || "";
  return last.replace(/^\d{8}T\d{6}_/, "") || null;
}

/**
 * Finds "diet_pdf_key" anywhere inside a (possibly nested) API object, so the
 * View button still works if the response nests "diet" differently.
 */
function findDietKey(obj, depth = 0) {
  if (!obj || typeof obj !== "object" || depth > 6) return null;
  if (typeof obj.diet_pdf_key === "string" && obj.diet_pdf_key) return obj.diet_pdf_key;
  for (const value of Object.values(obj)) {
    if (value && typeof value === "object") {
      const found = findDietKey(value, depth + 1);
      if (found) return found;
    }
  }
  return null;
}

export default function PatientDetail() {
  const location  = useLocation();
  const { id }    = useParams();

  const summaryPatient      = location.state?.patient           || { patient_id: id };
  const isAdmin              = location.state?.isAdmin           || false;
  const careCoordinatorId    = location.state?.careCoordinatorId || null;

  const [programData, setProgramData] = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [error,       setError]       = useState(null);
  const [activeTab,   setActiveTab]   = useState("metrics");
  const [graphMode,   setGraphMode]   = useState("all"); // "all" | "single"
  const [phoneCopied, setPhoneCopied] = useState(false);

  /* ── Diet plan upload state ── */
  const [dietUploading, setDietUploading] = useState(false);
  const [dietStatus,    setDietStatus]    = useState(null); // null | "success" | "error"
  const dietInputRef = useRef(null);

  useEffect(() => {
    const patientId = summaryPatient.patient_id || id;
    if (!patientId) { setLoading(false); return; }

    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const raw = isAdmin && careCoordinatorId
          ? await fetchAdminPatientDetail(patientId, careCoordinatorId)
          : await fetchPatientProgram(patientId);

        const data = extractObject(raw);
        if (!cancelled) setProgramData(data);
      } catch (err) {
        console.error("PatientDetail fetch error:", err);
        if (!cancelled) setError("Failed to load programme data.");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [id]);

  const profile          = programData?.user_profile || summaryPatient?.user_profile || {};
  const patientName      = profile.name || "Patient";
  const condition        = programData?.condition || summaryPatient?.condition || "—";
  const age               = profile.age ?? "—";
  const gender             = profile.gender || "—";
  const phone               = profile.phone_no || "—";
  const phaseValue =
  programData?.current_phase ?? summaryPatient?.current_phase;

  const PHASE_NAMES = {
    1: "Onboarding",
    2: "Active Monitoring",
    3: "Stabilisation",
    4: "Outcome & Continuation",
  };

  const currentPhase = PHASE_NAMES[phaseValue] || phaseValue || "—";

  /* ── Device battery (most recently updated device, if any) ── */
  const deviceInfoList = programData?.device_info || summaryPatient?.device_info || [];
  const latestBatteryInfo = getLatestBatteryInfo(deviceInfoList);
  const batteryValueDisplay = latestBatteryInfo?.battery != null
    ? `${latestBatteryInfo.battery}%${latestBatteryInfo.source ? `(${latestBatteryInfo.source})` : ""}`
    : "—";
  const batteryCapturedAt = formatISTDateTime(latestBatteryInfo?.updatedAt);
  const batteryTooltip = batteryCapturedAt
    ? `Captured at ${batteryCapturedAt} IST`
    : "No reading available";

  /* ── Diet plan (key comes back as diet.diet_pdf_key) ── */
  const dietKey = findDietKey(programData) || findDietKey(summaryPatient) || null;
  const dietFileName = getDietFileName(dietKey);

  const initials = (patientName || "P")
    .split(" ")
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const handleCopyPhone = async () => {
    if (!phone || phone === "—") return;
    try {
      await navigator.clipboard.writeText(phone);
      setPhoneCopied(true);
      setTimeout(() => setPhoneCopied(false), 1500);
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };

  /* ── Diet plan: pick a PDF and upload it ── */
  const handleDietFileChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = ""; // allow re-selecting the same file later
    if (!file) return;

    const isPdf = file.type === "application/pdf" || file.name.toLowerCase().endsWith(".pdf");
    if (!isPdf) {
      alert("Please select a PDF file.");
      return;
    }

    setDietUploading(true);
    setDietStatus(null);
    try {
      await uploadDietPlan({
        patientId: summaryPatient.patient_id || id,
        programId: programData?.program_id ?? summaryPatient?.program_id,
        file,
      });
      setDietStatus("success");

      // Silent refetch so the new diet_pdf_key shows up (View button) without a page reload.
      try {
        const patientId = summaryPatient.patient_id || id;
        const raw = isAdmin && careCoordinatorId
          ? await fetchAdminPatientDetail(patientId, careCoordinatorId)
          : await fetchPatientProgram(patientId);
        const data = extractObject(raw);
        if (data) setProgramData(data);
      } catch (refreshErr) {
        console.error("Diet refresh error:", refreshErr);
      }
    } catch (err) {
      console.error("Diet upload error:", err);
      setDietStatus("error");
      alert(err.message || "Failed to upload diet plan.");
    } finally {
      setDietUploading(false);
      setTimeout(() => setDietStatus(null), 2500);
    }
  };

  /* ── Diet plan: open the stored PDF in a new tab ── */
  const handleViewDiet = () => {
    if (!dietKey) return;
    const url = getDietPdfUrl(dietKey);
    if (!url) {
      alert("Diet plan exists, but no file URL is configured (set REACT_APP_FILE_BASE_URL or use a signed-URL endpoint).");
      return;
    }

    // A real anchor click is the most reliable way to open a new tab
    // (window.open with "noopener" is blocked/ignored in some browsers).
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  /* ── Currently selected tab (for the toolbar title) ── */
  const currentTab = TABS.find((t) => t.id === activeTab) || TABS[0];
  const CurrentTabIcon = currentTab.icon;

  return (
    <div className="cc-pd-root">
      <CCSidebar />

      <main className="cc-pd-main">
        {/* ── Tabs ── */}
        <div className="cc-pd-tabs">
          {TABS.map(({ id: tabId, text, icon: Icon }) => {
            const active = activeTab === tabId;
            return (
              <button
                key={tabId}
                className={`cc-pd-tab${active ? " active" : ""}`}
                onClick={() => setActiveTab(tabId)}
              >
                <Icon size={15} />
                <span>{text}</span>
              </button>
            );
          })}
        </div>

        {/* ── Patient info card — identical on every tab ── */}
        <div className="cc-pd-card">
          <div className="cc-pd-identity">
            <div className="cc-pd-avatar">{initials || "P"}</div>

            <div className="cc-pd-idcol">
              <span className="cc-pd-name">{patientName}</span>
              <span className="cc-pd-sub">
                {condition} &middot; Age:{age} &middot; {gender}
              </span>
              <span className="cc-pd-phone">
                <PhoneIcon /> {phone}
                <button
                  type="button"
                  className="cc-pd-copy-btn"
                  onClick={handleCopyPhone}
                  title={phoneCopied ? "Copied!" : "Copy phone number"}
                >
                  {phoneCopied ? <CheckIcon /> : <CopyIcon />}
                </button>
              </span>
            </div>
          </div>

          <div className="cc-pd-divider" />

          <div className="cc-pd-field cc-pd-field-center">
            <span className="cc-pd-field-label">Current Phase</span>
            <span className="cc-pd-phase-pill">{currentPhase}</span>
          </div>

          <div className="cc-pd-divider" />

          <div className="cc-pd-field cc-pd-field-center">
            <span className="cc-pd-field-label">Device Battery</span>
            <span
              className="cc-pd-battery-value"
              title={batteryTooltip}
              style={{
                color: "#2563eb",
                fontWeight: 500,
                fontSize: 12,
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
              }}
            >
              <BatteryIcon size={11} />
              {batteryValueDisplay}
            </span>
          </div>

          <div className="cc-pd-divider" />

          {/* ── Upload Diet Plan (PDF) ── */}
          <div className="cc-pd-field cc-pd-field-center">
            <span className="cc-pd-field-label">Diet Plan</span>
            <input
              ref={dietInputRef}
              type="file"
              accept="application/pdf,.pdf"
              style={{ display: "none" }}
              onChange={handleDietFileChange}
            />
            <div className="cc-pd-graphmode">
              <button
                type="button"
                className="cc-pd-graphmode-btn"
                onClick={() => dietInputRef.current?.click()}
                disabled={dietUploading}
                title={dietKey ? "Replace diet plan (PDF)" : "Upload diet plan (PDF)"}
                style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
              >
                {dietStatus === "success" ? <CheckIcon size={14} /> : <DietIcon />}
                {dietUploading
                  ? "Uploading…"
                  : dietStatus === "success"
                  ? "Uploaded"
                  : dietStatus === "error"
                  ? "Failed"
                  : dietKey
                  ? "Replace"
                  : "Upload"}
              </button>
              <button
                type="button"
                className="cc-pd-graphmode-btn"
                onClick={handleViewDiet}
                disabled={!dietKey}
                title={dietKey ? `View ${dietFileName || "diet plan"}` : "No diet plan uploaded yet"}
                style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
              >
                <EyeIcon /> View
              </button>
            </div>
          </div>
        </div>

        {/* ── Tab toolbar — separate bar, same structure on every tab ──
             Left: tab title + hint.  Right: tab-specific controls (if any). ── */}
        <div className="cc-pd-toolbar" style={TOOLBAR_STYLE}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
            <CurrentTabIcon size={16} />
            <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.25 }}>
              <span style={{ fontWeight: 600, fontSize: 14 }}>{currentTab.text}</span>
              <span style={{ fontSize: 11, color: "#6b7280" }}>{currentTab.hint}</span>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            {activeTab === "metrics" && (
              <>
                <div className="cc-pd-field cc-pd-field-center" style={{ flexDirection: "row", alignItems: "center", gap: 8 }}>
                  <span className="cc-pd-field-label">Graph View</span>
                  <div className="cc-pd-graphmode">
                    <button
                      className={`cc-pd-graphmode-btn${graphMode === "single" ? " active" : ""}`}
                      onClick={() => setGraphMode("single")}
                      title="Single graph view"
                    >
                      <LayersIcon /> Single
                    </button>
                    <button
                      className={`cc-pd-graphmode-btn${graphMode === "all" ? " active" : ""}`}
                      onClick={() => setGraphMode("all")}
                      title="All graphs view"
                    >
                      <GridIcon /> All
                    </button>
                  </div>
                </div>

                <div className="cc-pd-divider" style={{ alignSelf: "stretch" }} />

                <div className="cc-pd-cgm-icon-flip" style={{ display: "flex", alignItems: "center", gap: 25 }}>
                  <ExportCgm
                    patient={{
                      owner_id:     summaryPatient.patient_id,
                      user_profile: summaryPatient.user_profile,
                    }}
                  />
                  <UploadCgm
                    patient={{
                      owner_id:     summaryPatient.patient_id,
                      user_profile: summaryPatient.user_profile,
                    }}
                  />
                </div>
              </>
            )}

            {activeTab === "enhanced" && (
              <span
                className="cc-pd-heart-value"
                title="Live heart-rate stream"
                style={{
                  color: "#ff4d4f",
                  fontWeight: 500,
                  fontSize: 12,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <HeartIcon size={12} />
                Live
              </span>
            )}
          </div>
        </div>

        {/* ── Tab content ── */}
        <div className="cc-pd-panel">

          {activeTab === "journey" && (
            <>
              {loading && (
                <div className="cc-detail-loading">
                  <div className="cc-spinner" /><span>Loading programme…</span>
                </div>
              )}
              {error && <div className="cc-detail-error">{error}</div>}
              {!loading && !error && programData && (
                <CareJourney programData={programData} />
              )}
              {!loading && !error && !programData && (
                <div className="cc-detail-empty">No programme data found for this patient.</div>
              )}
            </>
          )}

          {activeTab === "metrics" && (
            <HealthView
              patient={{
                owner_id:     summaryPatient.patient_id,
                user_profile: summaryPatient.user_profile,
              }}
              graphMode={graphMode}
            />
          )}

          {activeTab === "medication" && (
            <MedicationView patient={summaryPatient} programData={programData} />
          )}

          {activeTab === "baseline" && (
            <>
              {loading && (
                <div className="cc-detail-loading">
                  <div className="cc-spinner" /><span>Loading programme…</span>
                </div>
              )}
              {error && <div className="cc-detail-error">{error}</div>}
              <BaselineView
                summaryPatient={summaryPatient}
                programData={loading ? null : programData}
              />
            </>
          )}

          {activeTab === "enhanced" && (
            <HeartRateMonitor
              patient={{
                owner_id: summaryPatient.patient_id,
              }}
            />
          )}

        </div>
      </main>
    </div>
  );
}